import { addClass, removeClass, hasClass } from '../_helpers';

export const floatLabels = () => {
    let floatLabelsCollection = document.querySelectorAll('[data-float-labels]');
    
    for(let floatLabelsEl of [...floatLabelsCollection]) {
        let prefixClass = floatLabelsEl.dataset.floatLabelsClassPrefix || 'field',
            fieldSelectors = [
                '[type=text]',
                '[type=email]',
                '[type=password]',
                '[type=tel]',
                'textarea',
                'select',
                '[data-float-label]'
            ],
            fields = floatLabelsEl.querySelectorAll(fieldSelectors.join(','));

        setClasses(prefixClass,fields);
    }
}

const setClasses = (prefixClass,fields) => {
    for(let field of fields) {
        let fieldParent = field.parentElement;
        if(hasClass(fieldParent,prefixClass)) {
            addClass(fieldParent,`${prefixClass}--floated-label`);

            if(isDirty(field)) {
                addClass(fieldParent, `${prefixClass}--floated-label-dirty`);
            } else {
                removeClass(fieldParent, `${prefixClass}--floated-label-dirty`);
            }

            field.addEventListener('input',() => {
                if(isDirty(field)) {
                    addClass(fieldParent, `${prefixClass}--floated-label-dirty`);
                } else {
                    removeClass(fieldParent, `${prefixClass}--floated-label-dirty`);
                }
            });

            field.placeholder = '';
        }
    }
}

const isDirty = field => {
    return field.value !== null && field.value !== undefined && field.value !== '';
}

(() => {
   floatLabels();
})();